<mat-dialog-content class="dialog-content">
    <section [ngSwitch]="type$">
        <div *ngSwitchCase="'count'">
            <app-inventory-counts></app-inventory-counts>
        </div>
        <div *ngSwitchCase="'financial'">
            <app-financial></app-financial>
        </div>
        <div *ngSwitchCase="'reorder'">
            <app-reorder></app-reorder>
        </div>
        <div *ngSwitchCase="'po'">
            <app-poworksheet></app-poworksheet>
        </div>
        <div *ngSwitchCase="'ps'">
            <app-psworksheet></app-psworksheet>
        </div>
        <div *ngSwitchCase="'print'">
            <app-print-count></app-print-count>
        </div>
        <div *ngSwitchCase="'invoice'">
            <app-invoice></app-invoice>
        </div>
    </section>
</mat-dialog-content>